angular.module('global.filters', [

    /*Global Filters*/
])
    .filter('limitChars', function () {
        return function (name, length, addDots) {
            if (addDots == null) {
                addDots = true;
            }
            if (!isEmpty(name)) {
                if (name.length > length) {
                    name = name.substr(0, length);

                    if (addDots) {
                        name += "...";
                    }
                }
            }
            return name;
        }
    })

    .filter('linkWithParam', function () {
        return function (param, link) {
            if (param) {
                return link + param;
            }
            return null;
        }
    })

    .filter('htmlReady', ['$sce', function ($sce) {
        return function (input) {
            return $sce.trustAsHtml(input);
        };

    }])

    .filter('removeHtmlTags', function () {
        return function (input) {
            if (input != null) {
                return input.replace(/<br \/>/, "\n").replace(/<[^>]*>/g, "");
            }
        }
    })

    .filter('formatDate', function () {
        return function (input) {
            let dateTime = new Date(input);
            let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September",
                "October", "November", "December"];
            let day = dateTime.getDate();
            let monthIndex = dateTime.getMonth();
            let year = dateTime.getFullYear();
            return monthNames[monthIndex] + ' ' + day + ', ' + ' ' + year;
        }
    })

    .filter('boldMatches', function () {
        return function (resultText, queryText) {
            if (queryText == null || resultText == null || queryText.trim() == "") {
                return resultText;
            }
            var queryArray = queryText.trim().split(" ");
            var resultArray = resultText.trim().split(" ");
            var response = [];

            for (var i = 0; i < resultArray.length; i++) {
                var resultWord = resultArray[i];
                var pattern = new RegExp("(" + queryArray.join("|") + ")", "gi");
                response.push(resultWord.replace(pattern, "<span class='bold'>$1</span>"))
            }

            return response.join(" ");
        }
    })

    .filter('currencyToSymbol', function () {
        return function (input) {
            switch (input) {
                case "USD":
                case "CAD":
                    return "$";
                case "EUR":
                    return "€";
                case "GBP":
                    return "£";
                case "EMU":
                    return "eMU";
                default:
                    return "";
            }
        }
    })

    .filter('imageByWidth', function () {
        return function (url, width) {
            if (url == null) {
                return null;
            }
            return url + '&width=' + width;
        }
    })

    .filter('imageByHeight', function () {
        return function (url, height) {
            if (url == null) {
                return null;
            }
            return url + '&height=' + height;
        }
    })

    .filter('timestampFormat', function () {
        return function (input) {
            switch (input) {
                case "USD":
                case "CAD":
                    return "$";
                case "EUR":
                    return "€";
                case "GBP":
                    return "£";
                default:
                    return "";
            }
        }
    })

    .filter('nullFiller', function () {
        return function (input) {
            if (input == null || "".localeCompare(input) == 0) {
                return "?";
            }
            return input;
        }
    })

    .filter('formatPrice', function () {
        return function (input) {
            return parseFloat(input);
        }
    })

    .filter('booleanEmoji', function () {
        return function (input) {
            return booleanEmoji(input);
        }
    })

    .filter('breakToParagraph', function () {
        return function (input) {
            if (input == null) {
                return '';
            }
            return input.replace(/\r/g, '').replace(/^(.*)$/mg, '<p>$1&nbsp;</p>');
        }
    })

